import React, { createContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

export const TokenContext = createContext();

const TokenContextProvider = ({ children }) => {
  const gateWayUrl = useSelector((state) => state.getIn(['config', 'gateWayUrl']));
  const myApiUrl = useSelector((state) => state.getIn(['config', 'myApiUrl']));
  const tokenKey = useSelector((state) => state.getIn(['config', 'tokenKey']));
  const tokenSecret = useSelector((state) => state.getIn(['config', 'tokenSecret']));
  const contextVal = useMemo(() => ({
    tokenKey, tokenSecret, myApiUrl, gateWayUrl,
  }),
  [tokenKey, tokenSecret, myApiUrl, gateWayUrl]);
  return (
    <TokenContext.Provider value={contextVal}>
      {children}
    </TokenContext.Provider>
  );
};

export default TokenContextProvider;

TokenContextProvider.propTypes = {
  children: PropTypes.node,
};
TokenContextProvider.defaultProps = {
  children: null,
};
